import { Component, OnInit, OnChanges, OnDestroy } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { FormArray, AbstractControl, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { FormTemplateDataEntryService } from "./../services/form-template-data-entry.service";
//import { ItemDataService } from './../services/item-data.service';
import { IDataEntryForm } from "./../models/data-entry.model";
import { TextDictionaryService } from "./../services/text-dictionary.service";
import textList from "../../assets/data/text-dictionary.json";
import { ZpDataService } from "./../services/zp-data.service";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "./../models/user.model";
import { Subscription } from "rxjs";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { PreviousUrlService } from "../services/previous-url.service";
import { Location } from "@angular/common";
import { DelegateHelpers } from "../helpers/delegate-helpers";
import { ThemeService } from "../theme/theme-service.service";
import { CurrencyConvertService } from "../services/currency-convert.service";

@Component({
  selector: "app-dynamic-view",
  templateUrl: "./dynamic-view.component.html",
  styleUrls: ["./dynamic-view.component.scss"],
})
export class DynamicViewComponent implements OnInit {
  public formResult: string = "no results yet";
  public myFormGroup: FormGroup = new FormGroup({});
  public myFormTemplate: IDataEntryForm;
  public templateName;
  public Id;
  public showHelp = false;
  public myTextList = textList;
  public subscription: Subscription;
  public subscription2: Subscription;
  public myItem = {};
  public buttonText = "Back";
  public currencySymbol = "&#163;";
  public dataIsLoaded: boolean = false;
  public myUser: IUser;
  public showAddButton = true;
  public showDeleteButton = true;
  public showFrequencies = false;
  public itemToDeleteId;
  public itemNameforDialog;
  public showDialog = false;
  public canEdit = false;
  public totalSharesValue = 0;
  public breadCrumbText: string;
  public mySharedPlans: {}[];
  public sharedPlan;
  public changePerMonth: string;
  public changePerYear: string;
  public result: number;
  public myValue;
  public showPlanReview: boolean;
  public now: number;
  public lastUpdateByName: any;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public currencyValue: Array<string>;
  public isCurrency: Array<boolean>;
  public currencyType: Array<string>;
  public currencyTypeDisplay: Array<string>;
  jointOwnersList: any[];
  isCommon: boolean;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ftService: FormTemplateDataEntryService,
    private dictService: TextDictionaryService,
    private zenplansDataService: ZpDataService,
    private fb: FormBuilder,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private previousUrlService: PreviousUrlService,
    public themeService: ThemeService,
    private location: Location,
    private delegateHelpers: DelegateHelpers,
    private currencyService: CurrencyConvertService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.templateName = params.get("templateName");
      this.Id = params.get("Id");
      this.subscription2 = this.userInfo.getMessage().subscribe((user) => {
        this.myUser = JSON.parse(user);
      });
      setInterval(() => {
        this.now = new Date().getFullYear();
      }, 1);
    });
  }
  ngOnChanges() { }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(
      this.templateName
    );
    let clientId = this.myUser
      ? this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id
      : undefined;
    if (clientId == this.myUser.sharedPlanUserId) {
      this.showPlanReview = false;
    } else {
      this.showPlanReview = true;
    }
    this.myItem = await this.zenplansDataService.getItem(
      this.Id,
      this.myFormTemplate.sectionTitle,
      clientId
    );
    this.lastUpdateByName = await this.zenplansDataService.getUserName(
      this.myItem["lastUpdateBy"]
    );
    await this.getFields();
    this.dataIsLoaded = true;
    if (
      this.myFormTemplate.sectionTitle
        .toLowerCase()
        .includes("general expenses")
    ) {
      this.showAddButton = false;
      this.showDeleteButton = false;
      this.showFrequencies = true;
    } else {
      this.showFrequencies = false;
    }
    this.canEdit = await this.getCanEdit(
      this.myUser,
      this.myFormTemplate.sectionTitle
    );
    this.mySharedPlans = await this.zenplansDataService.getSharedPlans(
      this.myUser
    );
    for (let sharedPlan of this.mySharedPlans) {
      if (clientId == this.mySharedPlans.includes("Id")) {
        this.sharedPlan = clientId;
      }
    }
  }

  getFrequency(field_id) {
    let frequencyField = this.myFormTemplate.fields.find(
      (field) => field.fieldid == field_id + "Freq"
    );
    return frequencyField;
  }
  async getFields() {
    var objectKeys = Object.keys(this.myItem); //this.myItem is the json for this item from the data
    var objectValues = Object.values(this.myItem);
    //remove from the template any fields that are not in the data
    //make a list of missing fields
    var notFound: string[] = [];
    this.myFormTemplate.fields.forEach((kk) => {
      var myValue = "";
      var index = objectKeys.findIndex(
        (ff) => ff.toLowerCase() === kk.fieldid.toLowerCase()
      );
      if (index == -1) {
        //this template field is not in the data
        notFound.push(kk.fieldid);
      } else {
        //Found, but value is empty - we do not want to show it in the view
        if (objectValues[index] == null || objectValues[index] == "") {
          notFound.push(kk.fieldid);
        }
      }
    });
    //remove the missing fields from the template. We don't want to show them in the view
    notFound.forEach((kk) => {
      let indexToRemove = this.myFormTemplate.fields.findIndex(
        (jj) => jj.fieldid == kk
      );
      this.myFormTemplate.fields.splice(indexToRemove, 1);
    });
    //connecting the tmplate fields with the stored fields
    this.currencyType = [];
    this.currencyValue = [];
    this.isCurrency = [];
    this.currencyTypeDisplay = []
    for (let templateObject of this.myFormTemplate.fields) {
      var myValue = "";

      var mySonList;
      var index = objectKeys.findIndex(
        (ff) => ff.toLowerCase() === templateObject.fieldid.toLowerCase()
      );
      var fieldValue = objectValues[index] as string;
      myValue = fieldValue;
      switch (templateObject.inputtype) {
        default: {
          if (Array.isArray(myValue) && templateObject.fieldid === 'newJointOwners') {
            console.log(`[${myValue}] is joint owner list.`);
            this.jointOwnersList = myValue;
            let o: any;
            for(o of this.jointOwnersList){
              if(o && o.share){
                if ((o && o.share) !== 100) {
                  this.isCommon = true
                  console.log('Shares != 100.')
                } else {
                  this.isCommon = false;
                  console.log('Shares == 100.')
                }
              }else{
                console.log('there are no shares.')
                this.isCommon = false;
              }
            }
          }
          if (typeof myValue === "boolean") {
            if (myValue) {
              myValue = "Yes";
            } else {
              myValue = "No";
            }
          } else if (typeof myValue === 'string') {
            if (this.currencyService.getCurrency(myValue)) {
              this.currencyService.getCurrency(myValue)
              this.currencyValue[templateObject.fieldid] = myValue.substring(4, 20);
              this.isCurrency[templateObject.fieldid] = true
            } else {
              this.isCurrency[templateObject.fieldid] = false;
            }
            let currency = this.currencyService.getCurrency(myValue)
            if (currency) {
              this.currencyTypeDisplay[templateObject.fieldid] = currency.display
              this.currencyType[templateObject.fieldid] = this.currencyService._currencyList
            } 
          }

          if (templateObject.fieldid == "shareCount" && myValue != "0") {
            this.totalSharesValue = +objectValues[index + 1] * +myValue;
          }
          if (templateObject.listSource == "property") {
            let myProperty = await this.zenplansDataService.getItem(
              this.myItem["propertyId"],
              "property",
              this.myUser.sharedPlanUserId
                ? this.myUser.sharedPlanUserId
                : this.myUser.Id
            );
            myValue = myProperty["itemName"];
          }
          this.myFormGroup.addControl(
            templateObject.fieldid,
            new FormControl(myValue)
          );
          break;
        }
      }
    }
    var yy = 0;
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key);
    return txt;
  }

  editItem() {
    let editUrl = this.myFormTemplate.editurl;
    if (!editUrl) {
      editUrl = this.myFormTemplate.url;
      editUrl = editUrl.replace(/s$/, "") + "-edit";
    }
    this.router.navigate(["/" + editUrl + "/" + this.Id]);
  }
  add() {
    let addUrl = this.myFormTemplate.addurl;
    if (!addUrl) {
      addUrl = this.myFormTemplate.addFromView;
      // addUrl = addUrl.replace(/s$/, "") + "_1";
    }
    this.router.navigate(["/" + addUrl]);
  }
  async deleteByEvent(choice) {
    if (choice === "Yes") {
      let clientId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      var deleted = await this.zenplansDataService.deleteItem(
        this.myItem["Id"],
        this.myFormTemplate.sectionTitle,
        clientId
      );
      if (deleted) {
        switch (this.myFormTemplate.sectionTitle) {
          case "insurance":
            if (this.myItem["propertyId"]) {
              this.zenplansDataService.removeInsuranceFromProperty(
                this.myItem["Id"],
                this.myItem["propertyId"],
                clientId
              );
            }
            break;
          case "mortgages":
            if (this.myItem["propertyId"]) {
              this.zenplansDataService.removeInsuranceFromProperty(
                this.myItem["Id"],
                this.myItem["propertyId"],
                clientId
              );
            }
            break;
          case "utilities":
            if (this.myItem["propertyId"]) {
              this.zenplansDataService.removeInsuranceFromProperty(
                this.myItem["Id"],
                this.myItem["propertyId"],
                clientId
              );
            }
            break;
        }
      }
      var Id: string;
      if (this.myUser.sharedPlanUserId) {
        //Id = this.myUser.delegate["delegateId"]
        Id = this.myUser.sharedPlanUserId;
      } else {
        Id = this.myUser.Id;
      }
      this.zenplansDataService.addLog(
        this.myFormTemplate.sectionTitle,
        this.itemToDeleteId,
        Id,
        "",
        JSON.stringify(this.myItem),
        "",
        "delete"
      );
      this.router.navigate(["/" + this.myFormTemplate.url]);
    }
    this.showDialog = !this.showDialog;
  }

  async callDialog() {
    let id = this.myItem["Id"];
    //let name = this.myItem["lookupText"]?this.myItem["lookupText"]:this.myItem["itemName"];
    let name = this.myItem["itemName"];
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }

  goto(url: string) {
    // this.location.back();
    let referrer = this.previousUrlService.getPreviousUrl();
    if (referrer == "/plan-review") {
      this.router.navigate([referrer]);
    } else {
      if (!url || url === "") {
        this.router.navigate(["/" + this.myFormTemplate.url]);
      } else {
        this.router.navigate(["/" + this.myFormTemplate.url + "/" + this.Id]);
      }
    }
  }

  async refresh() {
    await this.zenplansDataService.revalidateCache();
    this.zenplansDataService.changeMessage(
      JSON.stringify({ "cache revalidated": true })
    );
  }

  showMe(fieldName) {
    return true;
  }

  async getCanEdit(myUser, sectionTitle) {
    let retval = false;
    if (myUser.sharedPlanUserId) {
      //a delegate is looking at this info
      let categoryName = await this.zenplansDataService.getPlanCategory(
        sectionTitle
      );
      if (!categoryName) {
        return;
      }
      switch (categoryName) {
        case "my assets":
          if (myUser.delegate["assetsPermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my debts":
          if (myUser.delegate["debtsPermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my daily life":
          if (myUser.delegate["dailyLifePermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my digital life":
          if (myUser.delegate["digitalLifePermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my wishes":
          if (myUser.delegate["wishesPermission"] == "contributor") {
            retval = true;
          }

          break;
      }
      return retval;
    } else {
      //the client himself is deleting
      return true;
    }
  }

  onSubmit() {
    this.goto(this.myFormTemplate.url);
  }

  OnDestroy() {
    this.subscription.unsubscribe();
    this.subscription2.unsubscribe();
  }
}
